module.exports = __webpack_public_path__ + "logo.png?425dd06dc06c1fc4e1723e1f2247eab4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 121
// module chunks = 0